import { FormTextarea } from 'src/shared/components/FormComponents'
import { Column, Row } from 'src/shared/components/Semantic/all'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/shared/components/ui/card'
import { Button } from 'src/shared/components/ui/button'
import { UseFormReturn } from 'react-hook-form'
import { FormData } from '../types'
import { Copy, Check } from 'lucide-react'
import { useState } from 'react'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const Translations = ({
  methods,
}: {
  methods: UseFormReturn<FormData>
}) => {
  const { t } = useLocalization()
  const [copied, setCopied] = useState(false)

  const handleCopyPrompt = () => {
    const itemName = methods.getValues('item_name') || ''
    const itemDescription = methods.getValues('item_description') || ''

    const prompt = `Translate the following product information to Swedish and English. Return the translations in this exact format:

Title: [Swedish translation] || [English translation]
Description: [Swedish translation] || [English translation]

Product title: "${itemName}"
Product description: "${itemDescription}"

Important:
- Put Swedish first, then "||", then English
- Keep the translations concise and professional
- Only return the two lines in the specified format, nothing else`

    navigator.clipboard.writeText(prompt)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Card>
      <CardHeader>
        <Row className="justify-between items-start">
          <Column className="gap-1">
            <CardTitle>{t('Translations', 'Översättningar')}</CardTitle>

            <p className="text-xs">
              {t(
                'Write the English translation first, followed by "||" and then the Swedish translation.',
                'Skriv först engelsk översättning, följt av "||" och sedan svensk översättning.'
              )}
            </p>

            <p className="text-xs font-mono text-gray-800 px-2 py-1 rounded">
              <code className="whitespace-pre">
                {t(
                  'Example: White shirt || Vit tröja',
                  'Exempel: Vit tröja || White shirt'
                )}
              </code>
            </p>
          </Column>

          <Button type="button" size="sm" onClick={handleCopyPrompt}>
            {copied ? (
              <>
                <Check className="h-4 w-4 mr-1" />
                {t('Copied', 'Kopierad')}
              </>
            ) : (
              <>
                <Copy className="h-4 w-4 mr-1" />
                {t('Copy ChatGPT prompt', 'Kopiera ChatGPT prompt')}
              </>
            )}
          </Button>
        </Row>
      </CardHeader>

      <CardContent>
        <Column className="gap-4">
          <FormTextarea
            label={t('Title translations', 'Titelöversättningar')}
            name="item_name_translations"
            methods={methods}
            className="w-full"
            placeholder={t(
              'Enter title translations',
              'Skriv in titelöversättningar'
            )}
          />
          <FormTextarea
            label={t('Description translations', 'Beskrivningsöversättningar')}
            name="item_description_translations"
            methods={methods}
            className="w-full"
            placeholder={t(
              'Enter description translations',
              'Skriv in beskrivningsöversättningar'
            )}
          />
        </Column>
      </CardContent>
    </Card>
  )
}
